import Text from '@components/Text';
import Title from '@components/Title';
import { Accordion, AccordionItem } from '@components/Accordion/Accordion';
// import { qaArray } from '@modules/static/constants';

import s from './FaqContent.module.scss';
import useQuestionAnswer from '@hooks/useQuestionAnswers';

const FaqContent = () => {
  const { questionAnswers } = useQuestionAnswer();

  const qaArray = [
    {
      id: '0',
      title: 'Основные',
      accordion: questionAnswers,
    },
  ];

  return (
    <>
      <Title level={1} className={s.title}>
        Часто задаваемые вопросы
      </Title>

      {qaArray.map((item) => (
        <div key={item.id}>
          <Title level={2} className={s.subTitle}>
            {item.title}
          </Title>

          <Accordion>
            {item.accordion.map((accorionItem) => (
              <AccordionItem heading={accorionItem.question} key={accorionItem.id}>
                <Text fontgraphik className={s.content}>
                  <span dangerouslySetInnerHTML={{ __html: accorionItem?.answer || '' }} />
                </Text>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ))}
    </>
  );
};

export default FaqContent;
